class BackToTop {
  constructor() {
    this.backtotop = document.querySelector('.wp-backtotop');
    this.container = document.querySelector('.wp-backtotop__container');
    this.footer = document.querySelector('.wp-footer');
    this.prevnext = document.querySelector('.wp-prev-next__container');

    if (this.backtotop) {
      this.bindBackToTop();
      this.bindScrolling();
    }
  }

  bindBackToTop() {
    this.backtotop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  bindScrolling() {
    const update = () => {
      const obstacle = this.prevnext || this.footer;
      if (!obstacle || !this.container) {
        this.backtotop.style.transform = '';
        return;
      }

      const gap = 16;
      const obstacleTop = obstacle.getBoundingClientRect().top;
      const naturalBottom = parseFloat(window.getComputedStyle(this.container).bottom) || 0;
      const buttonBottom = window.innerHeight - naturalBottom;
      const overlap = buttonBottom + gap - obstacleTop;

      this.backtotop.style.transform = overlap > 0 ? `translateY(-${overlap}px)` : '';
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
}

export default BackToTop;
